/** Mirrors backend utils/hcpProfileFieldPolicy PROFILE_* constants (verification layer). */

export const PROFILE_VERIFICATION_LOCKED_PATHS = Object.freeze([
  'dateOfBirth',
  'idNumber',
]);

export const PROFILE_VERIFICATION_LOCK_MESSAGE =
  'This field cannot be edited after verification';
